import React from "react";
import { Stack, Typography, Box } from "@mui/material";

import Logo from "../../shared/Logo/Logo";
import ProgressBar from "../ProgressBar/ProgressBar";
// import LoadingComponent from "../../../UI/LoadingBar/LoadingBar";
import HeaderBarcode from "../../shared/HeaderBarcode/HeaderBarcode";
import FooterBarcode from "../../shared/FooterBarcode/FooterBarcode";

import "./GameLoader.scss";

const GameLoader = ({ progress, loaded }) => {
  return (
    <Stack className="game-load-screen">
      <Stack className="dotted-background">
        <Stack direction={"column"} className="container header">
          <HeaderBarcode />
        </Stack>
        <Stack className="content loader-content" spacing={2}>
          <Box className="notice-board">
            <Typography variant="h1" className="brand-text">
              WUTFO
            </Typography>
            <ProgressBar
              showLoadingText={true}
              progress={progress}
              label={loaded ? "Ready" : "Loading assets..."}
            />
          </Box>
        </Stack>
        <Stack direction={"row"} className="container footer">
          <Logo />
          <FooterBarcode />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default GameLoader;
